import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "0.1.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`dormitory_settings\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`default_rent_amount\` real DEFAULT 0 NOT NULL,
  \`default_water_rate\` real DEFAULT 0 NOT NULL,
  \`default_electric_rate\` real DEFAULT 0 NOT NULL,
  \`default_service_charge\` real DEFAULT 0 NOT NULL,
  \`default_due_day\` integer DEFAULT 5 NOT NULL,
  \`grace_period_days\` integer DEFAULT 0 NOT NULL,
  \`late_fee_type\` text DEFAULT 'fixed' NOT NULL,
  \`late_fee_amount\` real DEFAULT 0 NOT NULL,
  \`invoice_item_id\` text,
  \`income_account_id\` text,
  \`water_item_id\` text,
  \`electric_item_id\` text,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`ds_company_idx\` ON \`dormitory_settings\` (\`company_id\`);

CREATE TABLE IF NOT EXISTS \`dormitory_buildings\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`branch_id\` text,
  \`code\` text NOT NULL,
  \`name\` text NOT NULL,
  \`address\` text,
  \`total_floors\` integer DEFAULT 1 NOT NULL,
  \`contact_name\` text,
  \`contact_phone\` text,
  \`is_active\` integer DEFAULT 1 NOT NULL,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`db_company_code_idx\` ON \`dormitory_buildings\` (\`company_id\`, \`code\`) WHERE \`deleted_at\` IS NULL;
CREATE INDEX IF NOT EXISTS \`db_company_active_idx\` ON \`dormitory_buildings\` (\`company_id\`, \`is_active\`);

CREATE TABLE IF NOT EXISTS \`dormitory_rooms\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`building_id\` text NOT NULL,
  \`room_no\` text NOT NULL,
  \`floor_no\` integer DEFAULT 1 NOT NULL,
  \`room_type\` text,
  \`status\` text DEFAULT 'available' NOT NULL,
  \`rent_amount\` real DEFAULT 0 NOT NULL,
  \`deposit_amount\` real DEFAULT 0 NOT NULL,
  \`water_meter_no\` text,
  \`electric_meter_no\` text,
  \`area_sqm\` real,
  \`max_occupants\` integer DEFAULT 1 NOT NULL,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  FOREIGN KEY (\`building_id\`) REFERENCES \`dormitory_buildings\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`dr_company_building_idx\` ON \`dormitory_rooms\` (\`company_id\`, \`building_id\`);
CREATE INDEX IF NOT EXISTS \`dr_company_status_idx\` ON \`dormitory_rooms\` (\`company_id\`, \`status\`);
CREATE UNIQUE INDEX IF NOT EXISTS \`dr_building_room_idx\` ON \`dormitory_rooms\` (\`building_id\`, \`room_no\`) WHERE \`deleted_at\` IS NULL;

CREATE TABLE IF NOT EXISTS \`dormitory_tenants\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`customer_id\` text,
  \`tenant_code\` text,
  \`full_name\` text NOT NULL,
  \`phone\` text,
  \`email\` text,
  \`national_id\` text,
  \`address\` text,
  \`emergency_contact_name\` text,
  \`emergency_contact_phone\` text,
  \`is_active\` integer DEFAULT 1 NOT NULL,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);
CREATE INDEX IF NOT EXISTS \`dt_company_name_idx\` ON \`dormitory_tenants\` (\`company_id\`, \`full_name\`);
CREATE INDEX IF NOT EXISTS \`dt_company_code_idx\` ON \`dormitory_tenants\` (\`company_id\`, \`tenant_code\`);

CREATE TABLE IF NOT EXISTS \`dormitory_leases\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`lease_no\` text NOT NULL,
  \`room_id\` text NOT NULL,
  \`tenant_id\` text NOT NULL,
  \`start_date\` text NOT NULL,
  \`end_date\` text,
  \`move_in_date\` text,
  \`move_out_date\` text,
  \`rent_amount\` real DEFAULT 0 NOT NULL,
  \`deposit_amount\` real DEFAULT 0 NOT NULL,
  \`billing_day\` integer DEFAULT 1 NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  FOREIGN KEY (\`room_id\`) REFERENCES \`dormitory_rooms\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`tenant_id\`) REFERENCES \`dormitory_tenants\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`dl_company_status_idx\` ON \`dormitory_leases\` (\`company_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`dl_company_room_idx\` ON \`dormitory_leases\` (\`company_id\`, \`room_id\`);
CREATE INDEX IF NOT EXISTS \`dl_company_tenant_idx\` ON \`dormitory_leases\` (\`company_id\`, \`tenant_id\`);
CREATE UNIQUE INDEX IF NOT EXISTS \`dl_company_lease_no_idx\` ON \`dormitory_leases\` (\`company_id\`, \`lease_no\`) WHERE \`deleted_at\` IS NULL;

CREATE TABLE IF NOT EXISTS \`dormitory_billing_periods\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`period_no\` text NOT NULL,
  \`name\` text NOT NULL,
  \`period_month\` text NOT NULL,
  \`start_date\` text NOT NULL,
  \`end_date\` text NOT NULL,
  \`due_date\` text NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);
CREATE UNIQUE INDEX IF NOT EXISTS \`dbp_company_period_idx\` ON \`dormitory_billing_periods\` (\`company_id\`, \`period_month\`) WHERE \`deleted_at\` IS NULL;
CREATE INDEX IF NOT EXISTS \`dbp_company_status_idx\` ON \`dormitory_billing_periods\` (\`company_id\`, \`status\`);

CREATE TABLE IF NOT EXISTS \`dormitory_meter_readings\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`billing_period_id\` text,
  \`room_id\` text NOT NULL,
  \`lease_id\` text,
  \`meter_type\` text NOT NULL,
  \`previous_reading\` real DEFAULT 0 NOT NULL,
  \`current_reading\` real DEFAULT 0 NOT NULL,
  \`usage\` real DEFAULT 0 NOT NULL,
  \`unit_rate\` real DEFAULT 0 NOT NULL,
  \`amount\` real DEFAULT 0 NOT NULL,
  \`reading_date\` text NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`adjustment_reason\` text,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  FOREIGN KEY (\`billing_period_id\`) REFERENCES \`dormitory_billing_periods\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`room_id\`) REFERENCES \`dormitory_rooms\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`lease_id\`) REFERENCES \`dormitory_leases\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`dmr_company_period_idx\` ON \`dormitory_meter_readings\` (\`company_id\`, \`billing_period_id\`);
CREATE INDEX IF NOT EXISTS \`dmr_room_meter_idx\` ON \`dormitory_meter_readings\` (\`room_id\`, \`meter_type\`);
CREATE UNIQUE INDEX IF NOT EXISTS \`dmr_period_room_meter_idx\` ON \`dormitory_meter_readings\` (\`billing_period_id\`, \`room_id\`, \`meter_type\`) WHERE \`deleted_at\` IS NULL;

CREATE TABLE IF NOT EXISTS \`dormitory_bills\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`bill_no\` text NOT NULL,
  \`billing_period_id\` text NOT NULL,
  \`lease_id\` text NOT NULL,
  \`room_id\` text NOT NULL,
  \`tenant_id\` text NOT NULL,
  \`bill_date\` text NOT NULL,
  \`due_date\` text NOT NULL,
  \`rent_amount\` real DEFAULT 0 NOT NULL,
  \`water_amount\` real DEFAULT 0 NOT NULL,
  \`electric_amount\` real DEFAULT 0 NOT NULL,
  \`service_amount\` real DEFAULT 0 NOT NULL,
  \`discount_amount\` real DEFAULT 0 NOT NULL,
  \`late_fee_amount\` real DEFAULT 0 NOT NULL,
  \`total_amount\` real DEFAULT 0 NOT NULL,
  \`paid_amount\` real DEFAULT 0 NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`issued_at\` text,
  \`paid_at\` text,
  \`accounting_invoice_id\` text,
  \`accounting_receipt_id\` text,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  FOREIGN KEY (\`billing_period_id\`) REFERENCES \`dormitory_billing_periods\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`lease_id\`) REFERENCES \`dormitory_leases\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`room_id\`) REFERENCES \`dormitory_rooms\`(\`id\`) ON UPDATE no action ON DELETE no action,
  FOREIGN KEY (\`tenant_id\`) REFERENCES \`dormitory_tenants\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE UNIQUE INDEX IF NOT EXISTS \`dbill_company_bill_no_idx\` ON \`dormitory_bills\` (\`company_id\`, \`bill_no\`) WHERE \`deleted_at\` IS NULL;
CREATE UNIQUE INDEX IF NOT EXISTS \`dbill_period_lease_idx\` ON \`dormitory_bills\` (\`billing_period_id\`, \`lease_id\`) WHERE \`deleted_at\` IS NULL;
CREATE INDEX IF NOT EXISTS \`dbill_company_status_idx\` ON \`dormitory_bills\` (\`company_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`dbill_company_due_idx\` ON \`dormitory_bills\` (\`company_id\`, \`due_date\`);

CREATE TABLE IF NOT EXISTS \`dormitory_bill_lines\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`bill_id\` text NOT NULL,
  \`line_type\` text NOT NULL,
  \`description\` text NOT NULL,
  \`quantity\` real DEFAULT 1 NOT NULL,
  \`unit_rate\` real DEFAULT 0 NOT NULL,
  \`amount\` real DEFAULT 0 NOT NULL,
  \`sort_order\` integer DEFAULT 0 NOT NULL,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  FOREIGN KEY (\`bill_id\`) REFERENCES \`dormitory_bills\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`dbl_bill_idx\` ON \`dormitory_bill_lines\` (\`bill_id\`);
CREATE INDEX IF NOT EXISTS \`dbl_company_bill_idx\` ON \`dormitory_bill_lines\` (\`company_id\`, \`bill_id\`);
`,
};
